export default "__VITE_ASSET__C8cL1IAq__"